// React
import React from 'react'
import PropTypes from 'prop-types'

// Components
import BCartPicker from 'ui/blocks/Picker/types/cart'
import BPicker from 'ui/blocks/Picker'
import DateTimePicker from 'ui/components/Picker/DateTimePicker'
import InputField from 'ui/components/InputField'

// Hooks
import { usePicker } from 'ui/components/Picker/hooks'
import { useFormikContext } from 'formik'

// Shared
import moment from 'shared/lib/moment'
import { Field } from 'shared/form'
import { useTranslation } from 'shared/utils/useTranslation'

export const TimeslotsPicker = ({ children, onChange, onBlur, ...props }) => {
  const picker = usePicker()

  const { t } = useTranslation('user')
  const form = useFormikContext()

  const handleStartsAtChange = (value) => {
    onChange(value)
  }

  return (
    <BCartPicker.Timeslots disabled={props.disabled} disableStyling={props.isMobile}>
      <BPicker.Field>
        <BPicker.Label>{t('user.store.start_and_stop_date')}</BPicker.Label>
        <Field
          {...props}
          name="starts_at"
          onChange={handleStartsAtChange}
          onBlur={onBlur}
          component={DateTimePicker}
          blockedDays={(date) => !picker.isDaySelectable({ type: 'start', date })}
          inputDateRef={picker.refs.fromDateRef}
          to={props.from}
          mode="from"
          data-tid="Starts at picker"
          onOpen={props.onOpen?.bind(null, 'start', false)}
          useTimes={false}
          onMonthChange={props.onMonthChange.bind(null, { type: 'start', values: form.values })}
          withAvailability
          hideErrorLabel
          initialError
          hideLabel
        />
      </BPicker.Field>
      <BPicker.Field>
        <BPicker.TimeslotLabelWrapper>
          <BPicker.Label>{t('user.store.timeslot_from')}</BPicker.Label>
          <BPicker.Label>{t('user.store.timeslot_until')}</BPicker.Label>
        </BPicker.TimeslotLabelWrapper>
        <InputField
          {...props}
          field={{
            value: props.timeslotId,
            onChange: props.onTimeslotChange
          }}
          type="timeslots"
          mode="timeslot"
          inputRef={picker.refs.timeslotsRef}
          availabilities={props.timeslotsAvailability}
          disabled={!form.values.starts_at}
          data-tid="Timeslots"
          onOpen={props.onOpen?.bind(null, { type: 'start' }, moment(form.values.stops_at))}
          availabilityMode="timeslots"
          columns={1}
          error={props.hasError}
          usePortal={props.isMobile}
          hideErrorLabel
          initialError
          touched
        />
      </BPicker.Field>
      {children}
    </BCartPicker.Timeslots>
  )
}

TimeslotsPicker.propTypes = {
  children: PropTypes.node,
  timeslotId: PropTypes.string,
  timeslotsAvailability: PropTypes.array,
  onTimeslotChange: PropTypes.func,
  onOpen: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onMonthChange: PropTypes.func,
  onSelectionChange: PropTypes.func,
  isMobile: PropTypes.bool,
  disabled: PropTypes.bool,
  from: PropTypes.instanceOf(Date),
  hasError: PropTypes.bool
}
